import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Tooltip from '../../shared/Tooltip';
import { color } from '../../../app/theme';
import { NotifyRecipientType } from '../../../app/types';
import icHelpCircle from '../../../assets/images/svg/ic-help-circle.svg';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
      display: 'flex',
      alignItems: 'center',
    },
    block: {
      display: 'flex',
      alignItems: 'center',
    },
    option: {
      marginRight: 36,
    },
    radioInput: {
      fontSize: 15,
    },
  },
  {
    name: 'NotifyRecipient',
  },
);

const NotifyRecipient = ({ notifyRecipient, onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const radioComponent = Object.values(NotifyRecipientType).map(type => {
    return (
      <FormControlLabel
        key={`FormControlLabel-${type}`}
        className={classes.option}
        classes={{
          label: classes.radioInput,
        }}
        value={type}
        control={<Radio color="primary" />}
        label={t(`ecBinding:${type}`)}
      />
    );
  });

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        {t('ecBinding:notifyRecipient')}
        <Tooltip
          light
          placement="top"
          title={t('ecBinding:notifyRecipientTooltip')}
        >
          <img style={{ marginLeft: 4 }} src={icHelpCircle} alt="alert" />
        </Tooltip>
      </div>
      <FormControl component="fieldset">
        <RadioGroup
          row
          aria-label="default-display"
          name="default-display"
          value={notifyRecipient}
          onChange={e => onChange(e?.target?.value)}
        >
          {radioComponent}
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default NotifyRecipient;
